import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DanhSachPhieu from "../../../../component/DanhSachPhieu";
import LabelRequired from "../../../../component/LabelRequired";
import { TableCustom } from "../../../../component/table/table-custom/TableCustom";
import { congKhamColumn } from "../../../../phan-he-kham-benh/columns/tab-cong-kham/ColumnTabCongKham";
import { getDSCongKhamDaChiDinh, updateOrderGroupFields } from "../../../../phan-he-kham-benh/services/ChiDinhDVService";
import { CODE, ORDER_TYPE_ID, RESPONSE_MESSAGE, TERM_CLASS_IDS } from "../../../../utils/Constant";
import { getErrorMessage } from "../../../../utils/FormatUtils";
import { usePhanHeNoiTruContext } from "../../../PhanHeNoiTruContext";
import { getDsPhieuDichVu } from "../../../services/HanhChinhServices";
import { cancelCongKham, changeCongKham } from "../../../../phan-he-kham-benh/services/KhamBenhService";
import { toast } from "react-toastify";
import { getCategory } from "../../../../utils/AppFunction";
import { useTimeEditorManager } from "src/app/modules/component/time-editor/useTimeEditorManager";
import { TimeEditor } from "src/app/modules/component/time-editor/TimeEditor";
import { hasAuthority, KEY_AUTHORITIES } from "src/app/modules/utils/Permission";
import { CODE_CONTEXT_TAB_XET_NGHIEM, listContextDichVuCongKham } from "src/app/modules/phan-he-kham-benh/constants/ContextConstants";
import ContextMenu from "src/app/modules/component/ContextMenuV3";
import { SelectEditor, useSelectEditorManager } from "src/app/modules/component/select-editor";
import { seachUserMetadata } from "src/app/modules/auth/core/_requests";

export const CongKham = ({ treatmentSheetId }: any) => {
  const { benhNhanHanhChinh, statusChangedEvent } = usePhanHeNoiTruContext();
  const [dsPhieu, setDsPhieu] = useState<any[]>([]);
  const [selectedPhieu, setSelectedPhieu] = useState<any>([]);
  const [selectedIndex, setSelectedIndex] = useState<any>(0);
  const [dsXetNghiemDetail, setDsXetNghiemDetail] = useState<any[]>([]);
  const [listCongKham, setListCongKham] = useState<any>([]);
  const contextRef = useRef<HTMLDivElement | null>(null);
  const [contextMenu, setContextMenu] = useState<null | {
    x: number;
    y: number;
  }>(null);
  const [rowSeclectedByContextMenu, setRowSeclectedByContextMenu] = useState<any>();

  const allowEdit = !benhNhanHanhChinh?.concluded && hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.PHIEU_CHI_DINH);

  const indicationTimeManager = useTimeEditorManager({
    name: "indicationTime",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.indicationTime) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        indicationTime: updatedData.indicationTime
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, indicationTime: updatedData.indicationTime, date: moment(updatedData.indicationTime).format("DD/MM/YYYY") }
            : phieu
        )
      );
    }
  });

  const indicationPersonSelectManager = useSelectEditorManager({
    name: "indicationPerson",
    idFieldName: "id",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      indicationPerson: option?.fullName,
      indicationTime: selectedPhieu?.indicationTime
    }),
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.indicationPerson) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        indicationPerson: updatedData.indicationPerson
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, indicationPerson: updatedData.indicationPerson }
            : phieu
        )
      );
    },
    enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
  });

  const handleContextMenu = (e: any, row: any) => {
    e.preventDefault();
    setRowSeclectedByContextMenu(row?.original);
    setContextMenu({ x: e.clientX, y: e.clientY });
  };

  const handleClickOptionContextMenu = (value: any) => {
    const menuActions = {
      [CODE_CONTEXT_TAB_XET_NGHIEM.HUY_CONG_KHAM]: () => handleHuyCongKham(rowSeclectedByContextMenu),
    };
    menuActions[value?.code]?.();
    setContextMenu(null);
  };

  const handleHuyCongKham = async (row: any) => {
    try {
      const { data } = await cancelCongKham({
        orderId: row?.id
      });
      if (data?.code === CODE.SUCCESS) {
        toast.success("Hủy công khám thành công");
        handleGetDsPhieu();
      } else {
        let errorMessage = getErrorMessage(data);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  };

  const handleSelectPhieu = async (dataPhieu: any) => {
    try {
      setSelectedPhieu(dataPhieu);
      setSelectedIndex(dataPhieu?.index);
      let { data } = await getDSCongKhamDaChiDinh({
        orderGroupId: dataPhieu?.id,
        type: ORDER_TYPE_ID.CONG_KHAM,
      });
      if (CODE.SUCCESS === data?.code) {
        setDsXetNghiemDetail(data?.data || []);
      } else {
        setDsPhieu([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetDsPhieu = async () => {
    try {
      let { data } = await getDsPhieuDichVu(benhNhanHanhChinh?.treatmentId, ORDER_TYPE_ID.CONG_KHAM, treatmentSheetId);
      if (CODE.SUCCESS === data?.code) {
        let dsPhieuConverted = data?.data?.map((item: any, index: number) => {
          return {
            ...item,
            index,
            date: moment(item?.indicationTime).format("DD/MM/YYYY"),
          };
        });
        setDsPhieu(dsPhieuConverted || []);
        setDsXetNghiemDetail([]);
        if (dsPhieuConverted?.[selectedIndex]) {
          handleSelectPhieu(dsPhieuConverted?.[selectedIndex]);
        } else {
          setSelectedPhieu(null);
        }
      } else {
        setDsPhieu([]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleChangeCongKham = async (orderId: string, termId: string) => {
    try {
      let { data } = await changeCongKham(orderId, termId);
      if (CODE.SUCCESS === data?.code) {
        toast.success(RESPONSE_MESSAGE.SUCCESS);
        handleGetDsPhieu();
      } else {
        let errorMessage = data?.data?.[0]?.errorMessage || RESPONSE_MESSAGE.ERROR;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  };

  const handleGetListCongKham = async () => {
    try {
      const dichVuKhamBenh = await getCategory(TERM_CLASS_IDS.KHAM_BENH);
      setListCongKham(dichVuKhamBenh);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleGetListCongKham();
  }, []);

  useEffect(() => {
    benhNhanHanhChinh?.treatmentId && handleGetDsPhieu();
  }, [benhNhanHanhChinh?.treatmentId, statusChangedEvent, treatmentSheetId]);

  return (
    <Row className="h-100 spaces px-16 py-5">
      <div>
        <div className="pt-4 bg-white">
          <Row className="mx-0">
            <Col xs={4} className="d-flex align-items-center mb-3">
              <LabelRequired label="Mã phiếu" className="min-w-100px" />
              <span className="fw-light text-truncate">{selectedPhieu?.code || "..."}</span>
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Ngày y lệnh" className="min-w-100px" />
              <TimeEditor
                name="indicationTime"
                values={selectedPhieu}
                isEditingTime={indicationTimeManager.isEditingTime}
                editedTime={indicationTimeManager.editedTime}
                showValidationConfirm={indicationTimeManager.showValidationConfirm}
                validationMessage={indicationTimeManager.validationMessage}
                onEdit={indicationTimeManager.handleEditTime}
                onCancel={indicationTimeManager.handleCancelEdit}
                onSave={indicationTimeManager.handleSaveTime}
                onConfirmValidation={indicationTimeManager.handleConfirmValidation}
                onCancelValidation={indicationTimeManager.handleCancelValidation}
                onTimeChange={indicationTimeManager.setEditedTime}
                allowEdit={allowEdit}
              />
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Người chỉ định" className="min-w-100px" />
              <SelectEditor
                name="indicationPerson"
                values={{
                  indicationPerson: selectedPhieu?.indicationPerson
                }}
                options={[]}
                searchFunction={seachUserMetadata}
                searchObject={{ position: 1 }}
                urlData="data.content"
                getOptionLabel={(opt) => opt?.fullName || ""}
                inline={true}
                menuPlacement="top"
                isEditingSelect={indicationPersonSelectManager.isEditingSelect}
                editedValue={indicationPersonSelectManager.editedValue}
                showValidationConfirm={indicationPersonSelectManager.showValidationConfirm}
                showConfirmWithReason={indicationPersonSelectManager.showConfirmWithReason}
                validationMessage={indicationPersonSelectManager.validationMessage}
                onEdit={indicationPersonSelectManager.handleEditSelect}
                onCancel={indicationPersonSelectManager.handleCancelEdit}
                onSave={indicationPersonSelectManager.handleSaveSelect}
                onConfirmValidation={indicationPersonSelectManager.handleConfirmValidation}
                onCancelValidation={indicationPersonSelectManager.handleCancelValidation}
                onConfirmWithReason={indicationPersonSelectManager.handleConfirmWithReason}
                onCancelWithReason={indicationPersonSelectManager.handleCancelWithReason}
                onValueChange={indicationPersonSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Nơi chỉ định" className="min-w-100px" />
              <span className="fw-light text-truncate">{selectedPhieu?.requestDeptName || "..."}</span>
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Trạng thái" className="min-w-100px" />
              <span className="fw-light text-truncate">{dsXetNghiemDetail?.[0]?.currStatusName || "..."}</span>
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Nơi thực hiện" className="min-w-100px" />
              <span className="fw-light text-truncate">{selectedPhieu?.fulfillDeptName || "..."}</span>
            </Col>
            <Col xs={12} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Chẩn đoán" className="min-w-100px" />
              <span className="fw-light text-truncate">

              </span>
            </Col>
          </Row>
        </div>

        <div className="bg-white pt-2 mb-2">
          <DanhSachPhieu
            className="mb-2"
            handleSelectRowData={handleSelectPhieu}
            dsPhieu={dsPhieu as []}
            selectedIndex={selectedIndex}
          />

          <div className="tableLichSu border">
            <TableCustom<any>
              className={`spaces h-calc-vh-297`}
              columns={congKhamColumn}
              data={dsXetNghiemDetail || []}
              tableOptions={{
                listCongKham,
                handleChangeCongKham
              }}
              handleContextMenu={handleContextMenu}
            />
          </div>
          {contextMenu && (
            <div ref={contextRef}>
              <ContextMenu
                handleClickOptionContextMenu={handleClickOptionContextMenu}
                handleCloseMenu={() => setContextMenu(null)}
                data={listContextDichVuCongKham}
                target={contextMenu}
              />
            </div>
          )}
        </div>
      </div>
    </Row>
  );
};

export default CongKham;
